import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import TranslationIds from '../../../commons/translationIds';
import DateDropdown from '../../components/dateDropdown';
import { isDatePartsValid } from '../../../commons/utils/strings';

export default function renderBirthDate (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        subscribersFields,
        translate,
        translateWithValues,
        touched,
        widget,
    } = p;

    /* 
     * Note: dateOfBirth params in widget is the "dob" data in subscribers params
     */

    if (!fields || !fields.dateOfBirth) {
        return (<React.Fragment></React.Fragment>);
    }
 
    function getLabel () {
        if (fields.dateOfBirth === 1) {
            return `${translate(TranslationIds.REGISTRATION_LABEL_DOB)}*`;
        }
        return translate(TranslationIds.REGISTRATION_LABEL_DOB);
    }

    function getErrorText () {
        // console.log('getErrorText() subscribersFields.dob() ', subscribersFields.dob);
        if (isEmpty(subscribersFields.dob) || !isDatePartsValid(subscribersFields.dob)) {
            return translate(TranslationIds.REGISTRATION_REQUIRED_DOB);
        }
        return translateWithValues(TranslationIds.REGISTRATION_VALID_REQUIRED_AGE_NUMBER, { requiredAge: widget.requiredAge });
    }

    function getHelperText () {
        if (touched.dob && fieldErrors.dob) {
            return getErrorText();
        }
        return '';
    }
    
    return (
         <DateDropdown
            ecalClassName='ecal-reg-field-dob'
            error={fieldErrors.dob}
            helperText={getHelperText()}
            label={getLabel()}
            translate={translate}
            onChange={(v) =>  {
                setSubscribersFields({
                    dob: v,
                });
            }}

            onClose={() => {
                setSubscribersFields({
                    dob: subscribersFields.dob,
                });
            }}
         />
    );
}
